import './StreamingModal.css'

export default function StreamingModal({ track, links, loading, platforms, onClose }) {
    if (!track) return null

    return (
        <div className="stream-overlay" onClick={onClose}>
            <div className="stream-modal" onClick={e => e.stopPropagation()}>
                <button className="stream-modal__close" onClick={onClose} aria-label="Fermer">✕</button>
                <div className="stream-modal__header">
                    {track.art && <img src={track.art} alt="" className="stream-modal__art" loading="lazy" decoding="async" />}
                    <div className="stream-modal__info">
                        <span className="stream-modal__title">{track.title}</span>
                        <span className="stream-modal__artist">{track.artist}</span>
                        {track.album && <span className="stream-modal__album">{track.album}</span>}
                    </div>
                </div>
                <p className="stream-modal__label">Écouter sur</p>
                {loading ? (
                    <div className="stream-modal__loading">Recherche des liens…</div>
                ) : (
                    <div className="stream-modal__links">
                        {platforms.map(p => {
                            const url = links?.[p.key] || p.searchUrl(track.artist, track.title)
                            return (
                                <a
                                    key={p.key}
                                    href={url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="stream-modal__link"
                                >
                                    <span className="stream-modal__link-icon">{p.icon}</span>
                                    <span>{p.name}</span>
                                    <span className="stream-modal__link-arrow">→</span>
                                </a>
                            )
                        })}
                    </div>
                )}
            </div>
        </div>
    )
}
